import { Component, Input, OnChanges, OnInit, SimpleChanges, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ErrorDialogService } from 'src/app/shared/errors/error-dialog.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { countryList, RegistraionTypes } from '../../../../utils/constants/utility';

@Component({
  selector: 'app-receiver-taxsetting',
  templateUrl: './taxsetting.component.html',
  styleUrls: ['./taxsetting.component.scss'],
})
export class ReceiverTaxSettingComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() configurationReceiver = [];
  receiverRegistraionTypes;
  receiverTaxSetting: FormGroup;
  ReceiverDataSource = new MatTableDataSource<any>();
  ReceiverData: any;
  isValueChanged: boolean = false;
  list = [];

  columns: string[] = [
    'number',
    'receiverRegistrationType',
    'receiverRegistrationNumber',
    'receiverIssuingCountryCode',
    'Action',
  ];
  constructor(
    private fb: FormBuilder,
    private configService: ConfigService,
    private errorDialogService: ErrorDialogService
  ) {}

  ngOnInit(): void {
    this.receiverTaxSetting = this.fb.group({
      _id: '',
      config_id: '',
      customer_id: '',
      updated_by_username: '',
      updated_time: '',
      data: this.fb.array([]),
    });

    this.list = countryList;
    this.receiverRegistraionTypes = RegistraionTypes;
    this.getReceiverTypes(this.configurationReceiver);
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'configurationReceiver':
            this.getReceiverTypes(this.configurationReceiver);
            break;
        }
      }
    }
  }

  AddNewReceiverItem() {
    const control = this.receiverTaxSetting.get('data') as FormArray;
    control.insert(
      (this.receiverTaxSetting.get('data') as FormArray).controls.length + 1,
      this.addReceiverGroup()
    );
    this.ReceiverDataSource = new MatTableDataSource(control.controls);
  }

  DeleteReceiverItem(_formElement, i) {
    const control = this.receiverTaxSetting.get('data') as FormArray;
    control.removeAt(i);
    this.ReceiverDataSource = new MatTableDataSource(
      (this.receiverTaxSetting.get('data') as FormArray).controls
    );
  }

  private addReceiverGroup(): FormGroup {
    return this.fb.group({
      receiverRegistrationType: new FormControl('', Validators.compose([Validators.required])),
      receiverRegistrationNumber: new FormControl('', Validators.compose([Validators.required])),
      receiverIssuingCountryCode: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  getReceiverFormControlId(id, control) {
    return (this.receiverTaxSetting.get('data') as FormArray).controls[id].get(control);
  }

  getReceiverTypes(formData) {
    if (formData) {
      this.receiverTaxSetting.patchValue(formData);
      this.ReceiverData = formData;
      const ReceiverArray = formData;
      (this.receiverTaxSetting.get('data') as FormArray).clear();
      ReceiverArray.forEach(item => {
        const ReceiverGrp = this.addReceiverGroup();
        ReceiverGrp.patchValue(item);
        (this.receiverTaxSetting.get('data') as FormArray).push(ReceiverGrp);
      });
      this.ReceiverDataSource = new MatTableDataSource(
        (this.receiverTaxSetting.get('data') as FormArray).controls
      );
    }
  }

  saveReceiverConfig() {
    const config = this.receiverTaxSetting.value;
    config.config_id = 'receiver_tax_setting';
    this.configService.saveConfig(config).subscribe(() => {
      this.errorDialogService.openDialog('alert.configurationSuccess', false);
      this.isValueChanged = false;
      this.configService.putConfig(config.config_id, config.data);
    });
  }

  ngAfterViewInit() {
    this.isAnyValueUnChanged();
  }

  isAnyValueUnChanged() {
    setTimeout(() => {
      setTimeout(
        function () {
          this.receiverTaxSetting.valueChanges.subscribe(() => {
            this.isValueChanged = true;
          });
        }.bind(this),
        0
      );
    }, 1000);
  }
}
